import { render, staticRenderFns } from "./dealers.vue?vue&type=template&id=17a4b0d6&"
import script from "./dealers.vue?vue&type=script&lang=js&"
export * from "./dealers.vue?vue&type=script&lang=js&"
import style0 from "./dealers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports